// extracted by mini-css-extract-plugin
export var cardContainer = "_n6-0";
export var cardHeader = "_n6-2";
export var collapsedState = "_n6-3";
export var dragHandle = "_n6-5";
export var dragHandleIcon = "_n6-6";
export var dragging = "_n6-1";
export var titleArea = "_n6-4";